import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { GET_VOICE_WATCH_DASHBOARD } from './agents.GraphQL';

export interface VoiceWatchDashboardCriteria {
  tenantId: string;
  expiresAt: string;
  language: string;
}

@Injectable({ providedIn: 'root' })
export class AgentsService {
  constructor(private apollo: Apollo) {}

  getVoiceWatchDashboardUrl(criteria: VoiceWatchDashboardCriteria): Promise<string> {
    return firstValueFrom(
      this.apollo
        .query<{ voiceWatchDashboard: { url: string } }>({
          query: GET_VOICE_WATCH_DASHBOARD,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        })
        .pipe(map((res) => res.data.voiceWatchDashboard.url))
    );
  }
}
